// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__30qUX","row":"ProcedureTreatmentSummary_row__U5r2i"};